import * as React from "react";
import { useLanguage } from "../../Language";
import { Typography } from "@mui/material";

interface LSSerialIssueInformationProps {
  chronology: string;
  enumeration: string;
}
export const LSSerialIssueInformation = ({
  chronology,
  enumeration,
}: LSSerialIssueInformationProps) => {
  const { translate } = useLanguage();

  return (
    <>
      {chronology?.length && (
        <Typography component={"div"} variant={"subtitle2"}>
          {translate("chronology")}: {chronology}
        </Typography>
      )}
      {enumeration?.length && (
        <Typography component={"div"} variant={"subtitle2"}>
          {translate("numbering")}: {enumeration}
        </Typography>
      )}
    </>
  );
};
